import React from 'react';
import MatriculasEstudiantesTable from './TableMatriculasEstudiantes/TableMatriculasEstudiantes';

const MatriculasEstudiantes = () => {
  return <MatriculasEstudiantesTable/> ;
};

export default MatriculasEstudiantes;
